module.exports = __webpack_public_path__ + "925ab8a6bf663f32e696c5c3f0bfd04e.jpg";